import React from 'react';
import MoonLoader  from "react-spinners/MoonLoader";

const Loading = () => {
    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(1, 0, 29, 0.6)',
            zIndex: 9999,
        }}>
            ...
        </div>
    );
}

export default Loading;
